import React from 'react';
import { HStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { analyticsIds } from '../../../../../../../../../constants/analyticsIds';
import ActivityLogFilterButton from '../ActivityLogFilterButton';

const ActivityLogTypeFilters = ({ insuredId, recordId }) => (
  <HStack mb={2} spacing="25px">
    <ActivityLogFilterButton
      dataAnalyticsId={analyticsIds.insuredProfilePage.activityLog.allActivityFilterButton}
      insuredId={insuredId}
      recordId={recordId}
      title="All Activity"
      type="all_activity"
    />
    <ActivityLogFilterButton
      dataAnalyticsId={analyticsIds.insuredProfilePage.activityLog.actionsFilterButton}
      insuredId={insuredId}
      recordId={recordId}
      title="Actions"
      type="activity"
    />
    <ActivityLogFilterButton
      dataAnalyticsId={analyticsIds.insuredProfilePage.activityLog.commentsFilterButton}
      insuredId={insuredId}
      recordId={recordId}
      title="Comments"
      type="comment"
    />
  </HStack>
);

ActivityLogTypeFilters.propTypes = {
  insuredId: PropTypes.number.isRequired,
  recordId: PropTypes.number.isRequired
};

export default ActivityLogTypeFilters;
